export interface SseMessage {
  id?: string;
  event: string;
  data: string;
}

/** Incremental Server-Sent Events parser: feed it chunks, get complete messages back. */
export function createSseParser() {
  let buffer = '';

  function parseBlock(block: string): SseMessage | null {
    const msg: SseMessage = { event: 'message', data: '' };
    const data: string[] = [];
    for (const raw of block.split('\n')) {
      const line = raw.endsWith('\r') ? raw.slice(0, -1) : raw;
      if (!line || line.startsWith(':')) continue;
      const i = line.indexOf(':');
      const field = i === -1 ? line : line.slice(0, i);
      const value = i === -1 ? '' : line.slice(i + 1).replace(/^ /, '');
      if (field === 'data') data.push(value);
      else if (field === 'event') msg.event = value;
      else if (field === 'id') msg.id = value;
    }
    if (!data.length && msg.event === 'message') return null;
    msg.data = data.join('\n');
    return msg;
  }

  return {
    push(chunk: string): SseMessage[] {
      buffer += chunk.replace(/\r\n/g, '\n');
      const out: SseMessage[] = [];
      let idx: number;
      while ((idx = buffer.indexOf('\n\n')) !== -1) {
        const block = buffer.slice(0, idx);
        buffer = buffer.slice(idx + 2);
        const msg = parseBlock(block);
        if (msg) out.push(msg);
      }
      return out;
    },
  };
}

/** Reads an SSE response body until it ends or the signal aborts. */
export async function readSse(res: Response, onMessage: (m: SseMessage) => void, signal: AbortSignal) {
  if (!res.body) return;
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  const parser = createSseParser();
  try {
    while (!signal.aborted) {
      const { value, done } = await reader.read();
      if (done) return;
      for (const m of parser.push(decoder.decode(value, { stream: true }))) onMessage(m);
    }
  } finally {
    reader.releaseLock();
  }
}
